import { render, staticRenderFns } from "./RedeemedPromoVouchers.vue?vue&type=template&id=1e2fd353&"
import script from "./RedeemedPromoVouchers.vue?vue&type=script&lang=js&"
export * from "./RedeemedPromoVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports